export default {"src":"/_next/static/media/product_mob_line.31c14f6f.svg","height":41,"width":12,"blurWidth":0,"blurHeight":0};